import React, { useState, useEffect, useRef } from 'react';
import './ShopLazyImage.css';

const ShopLazyImage = ({ src, alt, className }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.1
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const handleImageLoad = () => {
    setIsLoaded(true);
  };

  return (
    <div ref={containerRef} className="shop-lazy-image-container">
      <div className={`shop-image-placeholder ${isLoaded ? 'hidden' : ''}`} />
      {isInView && (
        <img
          ref={imgRef}
          src={src}
          alt={alt}
          className={`shop-lazy-image ${isLoaded ? 'loaded' : ''} ${className || ''}`}
          onLoad={handleImageLoad}
        />
      )}
    </div>
  );
};

export default ShopLazyImage; 